import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'

const URL = `/landing/symbols`

const getSymbols = (): AxiosPromise => apiFetch(URL, { method: `GET` })

export default getSymbols
